import { get, post } from '../../../services/request';

//--------Fetch Capacity vs Demand Main Dropdown Binding List---//
export const fetchCapacityVSDemandDDList = () => {
    return get("CapacityVsDemand/GetAllCapacityVsDemandTablePublishedReportListEncore");
}

//--------Fetch Capacity vs Demand Report Table Data------//
export const fetchCapacityVSDemandReportData = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandReportsWithPaginationEncore", payload);
}

//--------Fetch Available Shift Filter DDList-------//
export const fectchAvailableFilterDDList = (reportid) => {
    return get(`CapacityVsDemand/GetCapsVsDemandFilterDDList?ReportId=${reportid}`, {
    })
};

//--------Fetch Legend Data-------//
export const fetchLegendData = (legendid) => {
    return get(`CapacityVsDemand/GetCapsVsDemandLegendByCapsReportID?id=${legendid}`, {
    })
};

//--------Fetch Available Shift Data-------//
export const fecthAvailabeshiftData = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandTabDetailsById", payload);
}

//--------Fetch Available Shift RPCE Data---//
export const fetchAvailableShiftData = (payload) => {
    return post("CapacityVsDemand/GetCapacityVSDemandAvailableShiftsRPCEWithPagination", payload);
}

//--------Fetch Available Shift Worklist Data---//
export const fetchAvailableShiftWorklist = (payload) => {
    return post("CapacityVsDemand/GetCapacityVSDemandAvailableShiftsByIDWithPagination", payload);
}

//--------Fetch RPCE DATA in CspVsDemand tab---//
export const fetchCapsVsDemandShiftRPCE = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandRPCEWithPagination", payload);
}

//--------Fetch Worklist DATA in CspVsDemand tab---//
export const fetchCapsVsDemandShiftWorklist = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandDetailsByIdWithPagination", payload);
}

//--------Fetch Capacity Details in CapsVsDemand tab on popup---//
export const fetchCapacityPopupDetails = (payload) => {
    return post("CapacityTable/GetCapacityRPCEDetails", payload);
}

//--------Fetch Worklist Details in CapsVsDemand tab on popup---//
export const fetchWorklistDetailsData = (payload) => {
    return post("CapacityTable/GetCapacityDetails", payload);
}

//--------Fetch Capacity Vs Demand Get By Id Details---//
export const fetchCapacityVsDemandDetailsById = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandById", payload);
}

//--------Fetch Notes Details---//
export const fetchNotesDetails = (payload) => {
    return post("Common/GetReportNoteEncore", payload);
}

//--------Save Notes Details---//
export const saveNotesRequest = (payload) => {
    return post("Common/UpdateReportNoteEncore", payload);
}

//--------Export on RPCE data in Available shift---//
export const exportRPCEDataRequest = (rpceid) => {
    return get(`CapacityVsDemand/ExportToCSVCapacityVsDemandAvailableShiftRPCE?CapacityVsDemandTableID=${rpceid}`
    );
};

//--------Export on Worklist data in Available shift---//
export const exportWorklistRequest = (worklistid) => {
     return get(`CapacityVsDemand/ExportToCSVCapacityVsDemandAvailableShift?CapacityVsDemandTableID=${worklistid}`, {
    })
}

//--------Export RPCE Data in Caps Vs Demnad tab---//
export const exportRPCEDataCapsVsDemand = (rpceId) => {
    return get(`CapacityVsDemand/ExportToCSVCapacityVsDemandRPCE?CapacityVsDemandTableID=${rpceId}`
    );
}

//--------Export Worklist Data in Caps Vs Demnad tab---//
export const exportWorklistCapsVsDemandRequest = (worklistId) => {
    return get(`CapacityVsDemand/ExportToCSVCapacityVsDemandTable?CapacityVsDemandTableID=${worklistId}`
    );
}

//--------Publish Capacity vs Demand Report---//
export const PublishCapsVsDemandReport = (payload) => {
    return post("CapacityVsDemand/PublishCapacityVsDemandReport", payload);
}

//--------Export Capacity vs Demand Report---//
export const exportCapacityVsDemandReport = (id) => {
    return get(`CapacityVsDemand/ExportToCSVCapacityVsDemandReport?CapacityVsDemandTableID=${id}`, {
    });
}

//--------Delete Capacity vs Demand Report---//
export const deleteCapsVsdemandRequest = (CapsVsdemandid) => {
    return get(`CapacityVsDemand/DeleteCapacityVsDemandReport?CapacityVsDemandTableID=${CapsVsdemandid}`);
}

//--------Generate Capacity Vs Demand Report (Encore)---//
export const generateCapacityVsDemandReportEncore = (payload) => {
    return post("CapacityVsDemand/GenerateCapacityVsDemandReportEncore", payload);
}

//--------Fetch Capacity Vs Demand Tab Details With Pagination (Encore)---//
export const fetchCapacityVsDemandTabDetailsEncore = (payload) => {
    return post("CapacityVsDemand/GetCapacityVsDemandTabDetailsByIdWithPaginationEncore", payload);
}

//--------Fetch Available Shifts Tab Details With Pagination (Encore)---//
export const fetchAvailableShiftsTabDetailsEncore = (payload) => {
    return post("CapacityVsDemand/GetAvailableShiftsTabDetailsByIdWithPaginationEncore", payload);
}

//--------Export Capacity Vs Demand Report (Encore)---//
export const exportCapacityVsDemandReportEncore = (payload) => {
    return post("CapacityVsDemand/ExportToCSVCapacityVsDemandReportEncore", payload);
}

//--------Fetch Access To Demand Details With Pagination (hour cell popup)---//
export const fetchAccessToDemandDetails = (payload) => {
    return post("CapacityVsDemand/GetAccessToDemandWithPagination", payload);
}

//--------Delete Capacity Vs Demand Report (Encore)---//
export const deleteCapsVsdemandEncoreRequest = (CapacityVsDemandTableID) => {
    return get(`CapacityVsDemand/DeleteCapacityVsDemandReportEncore?CapacityVsDemandTableID=${CapacityVsDemandTableID}`);
}

//--------Publish Capacity Vs Demand Report (Encore)---//
export const publishCapacityVsDemandReportEncore = (payload) => {
    return post("CapacityVsDemand/PublishCapacityVsDemandReportEncore", payload);
}

//--------Fetch Worklist By Worklist Group Dropdown (cascading Worklist filter)---//
// Shared DemandTable endpoint -- same reuse as the capacityTable module's cascade
// (CapacityTableServices.js). Returns only worklists mapped to the given groups.
export const fetchWorklistByWorklistGroupDDList = (worklistGroupIds) => {
    return get(`DemandTable/GetWorklistByWorklistGroupDropDown?worklistGroupIds=${worklistGroupIds}`);
}